var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, Watch, } from "vue-property-decorator";
import EditDataElementLabel from "../../components/articleattributes/editdataelementlabel.vue";
import { isNumber, } from "../utilities/wsi4_typeguards";
let ThreadingElement = class ThreadingElement extends Vue {
    constructor() {
        super(...arguments);
        this.num = 0;
    }
    numChanged(e) { return e; }
    get elementKey() { return "threading"; }
    get showInfoIcon() { return this.networkBroker.configuration.editDataConfiguration[this.elementKey].showInfoIcon; }
    get attachmentsValid() { return this.num <= 0 || this.attachmentsLength > 0; }
    get valid() { return isNumber(this.num) && this.num >= 0 && this.attachmentsValid; }
    created() {
        if (!isNumber(this.value.numThreads)) {
            return;
        }
        this.num = this.value.numThreads;
    }
    onValueChanged(val, _oldVal) {
        if (!isNumber(val.numThreads)) {
            return;
        }
        this.num = val.numThreads;
    }
    onNumChanged(_val, _oldVal) { this.numChanged(this.num); }
};
__decorate([
    Prop({ required: true })
], ThreadingElement.prototype, "value", void 0);
__decorate([
    Prop({ required: true })
], ThreadingElement.prototype, "attachmentsLength", void 0);
__decorate([
    Inject()
], ThreadingElement.prototype, "i18n", void 0);
__decorate([
    Inject()
], ThreadingElement.prototype, "networkBroker", void 0);
__decorate([
    Emit()
], ThreadingElement.prototype, "numChanged", null);
__decorate([
    Watch("value")
], ThreadingElement.prototype, "onValueChanged", null);
__decorate([
    Watch("num")
], ThreadingElement.prototype, "onNumChanged", null);
ThreadingElement = __decorate([
    Component({
        components: {
            EditDataElementLabel,
        },
        name: "ThreadingElement",
    })
], ThreadingElement);
export default ThreadingElement;
